export const trackEvent = (eventType) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventType,
  })
}
